import { GET_AD } from "./const";

export default {
    [GET_AD](state) {
        return state.ad;
    }
}